import fallbackFormatter from './fallbackFormatter';
import Encodable from '../../options/Encodable';
export default function createFormatter({
  formatType,
  format,
  formatInLocalTime
}) {
  if (formatType === 'time') {
    const formatter = Encodable.resolveTimeFormat({
      format,
      formatInLocalTime
    });
    return value => formatter(value);
  }

  if (formatType === 'number' || typeof format !== 'undefined' && format.length > 0) {
    const formatter = Encodable.resolveNumberFormat(format);
    return value => formatter(value);
  }

  return fallbackFormatter;
}